
import { useEffect, useState } from "react";
import { useDataFetching } from "./hooks/useDataFetching";
import { useFilterLogic } from "./hooks/useFilterLogic";
import { useSortData } from "../hooks/useSortData";
import { useExportData } from "./hooks/useExportData";
import { CRMData } from "./types";
import { usePagination } from "../hooks/usePagination";

export const useCRMData = () => {
  const { crmData, isLoading, error, fetchCRMData } = useDataFetching();
  const { filters, filteredData: baseFilteredData, showFilters, setFilters, setShowFilters } = useFilterLogic(crmData);
  const [dataToSort, setDataToSort] = useState<CRMData[]>([]);
  const { sortConfig, sortedData, sortData } = useSortData(dataToSort);
  const { downloadExcel, exportExcel } = useExportData();
  
  // Pagination integration
  const { 
    currentPage, 
    totalPages, 
    paginatedData: filteredData, 
    goToPage, 
    nextPage, 
    prevPage 
  } = usePagination({ 
    data: sortedData, 
    itemsPerPage: 20 
  });

  // Connect filter and sort logic
  useEffect(() => {
    setDataToSort(baseFilteredData);
  }, [baseFilteredData]);

  return {
    crmData,
    filteredData,
    allFilteredData: sortedData, // All filtered+sorted data (not paginated)
    isLoading,
    error,
    sortConfig,
    filters,
    showFilters,
    // Pagination
    currentPage,
    totalPages,
    goToPage,
    nextPage,
    prevPage,
    // Other functions
    setFilters,
    setShowFilters,
    sortData,
    downloadExcel: () => downloadExcel(sortedData),
    exportExcel: () => exportExcel(sortedData)
  };
};
